import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { msalInstance, loginRequest } from "../services/entraId";

import { initializeChatbot } from "../api/chatBot";
import { setInLocalStorage, removeInLocalStorage } from "../api/helpers";

// chat context
import { useChat } from "./chat-provider";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const [messages, setMessages] = useState([]);

  const { addMessage } = useChat();

  const navigate = useNavigate();

  useEffect(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts && accounts.length > 0) {
      setUser(accounts[0]);
    }
  }, []);

  const handleEntraIDLogin = async () => {
    try {
      const loginResponse = await msalInstance.loginPopup(loginRequest);
      const token = loginResponse.accessToken;

      setUser(loginResponse.account);

      const response = await initializeChatbot(token);

      setInLocalStorage("chat_id", response.bot_id);

      addMessage(response.message, "bot");

      navigate(`/chat/`);
    } catch (error) {
      console.error("Fehler bei der Entra ID Anmeldung:", error);
    }
  };

  const logout = async () => {
    removeInLocalStorage("chat_id");

    msalInstance
      .logoutPopup()
      .then(() => {
        setUser(null);
        navigate("/");
      })
      .catch((error) => {
        console.error("Fehler beim Entra ID Logout:", error);
      });
  };

  const value = {
    user,
    messages,
    setMessages,
    handleEntraIDLogin,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
